import { gql } from '@apollo/client';

export const FETCH_WHITELISTED_LINKS = gql`
  query FetchWhitelistedLinksQuery(
    $search: String!
    $blocked: Boolean = null
    $selectedDate: [String!] = null
    $limit: Float!
    $cursorPaging: String
  ) {
    fetchWhitelistedLinks(
      search: $search
      blocked: $blocked
      selectedDate: $selectedDate
      limit: $limit
      cursorPaging: $cursorPaging
    ) {
      pagingMetadata {
        cursor
        hasNext
      }
      links {
        _id
        url
        blocked
        createdAt
        updatedAt
      }
    }
  }
`;
